import kenny from "./thumbnails/kennyonmushrooms.jpg"
import awesomeSolos from "./thumbnails/awesomesolos.gif"
import blocks from "./thumbnails/blocks.png"
import tape from "./thumbnails/tape.jpg"
import manual from "./thumbnails/manual.jpg"
import sakirt from "./thumbnails/sakirt.png"
import cacophony from "./thumbnails/cacophony.gif"
import silly from "./thumbnails/sillyimages.jpg"
import randyt from "./thumbnails/randyt.png"
import youseq from "./thumbnails/youseq.png"
import youtubeplay from "./thumbnails/youtubeplayer.png"
import letgo from "./thumbnails/itssafetojustletgo.jpg"
import sumeyye from "./thumbnails/sumeyye.jpg"
import rumba from "./thumbnails/rumba.gif"
import riset from "./thumbnails/riset.jpg"
import dew from "./thumbnails/dew.gif"
import missingno2 from "./thumbnails/missingno2.jpg"
import darkwebb from "./thumbnails/darkwebb.jpg"
import website from "./thumbnails/website.jpg"
import pcamel from "./thumbnails/pcamel.jpg"
import pppb from "./thumbnails/pppb.gif"
import avoid from "./thumbnails/avoid.png"
import vedat from "./thumbnails/vedat.jpg"
import algocuts from "./thumbnails/algocuts.gif"
import nerves from "./thumbnails/nerves.jpg"
 
 
 export const projects = [
  {
    id: 1,
    name: "Self Survelliance Mosaics",
    shortDescription: "I tracked my browser activity to download all images I encounter, and made image Mosaics with them using AndreaMosaic.",
    year: "2019",
    tags: ["all","audio","remix","video","composition"],
    image: "https://ipfs.daonomic.com/ipfs/QmdZZiumxLCaDuGXeyvNb7TDoLDCHk3DGYmL84jJPRAq26",
    url: "https://app.rarible.com/ssm/onsale"
  },
  {
    id: 1,
    name: "RareBERK Gallery",
    shortDescription: "Berk's virtual gallery at CryptoVoxels",
    year: "2019",
    tags: ["all","audio","remix","video","composition"],
    image: "https://lh3.googleusercontent.com/EQK1Zq2YktA1De2x4oqVM4SMg_fGcLrBMvXszssaHeeIEnbYZhoiSRbzC0D6FNzo-e9Hgno9P2UHZ9pcN_L7dLpS2Q",
    url: "https://www.cryptovoxels.com/parcels/2477"
  },
  {
    id: 1,
    name: "untitled",
    shortDescription: "text published in Trance Zine Issue 2: Nerves",
    year: "2020",
    tags: ["all","audio","remix","video","composition"],
    image: nerves,
    url: "http://trancezine.com/ozdemir.html"
  },
  {
    id: 1,
    name: "BedroomLiveOut Audiovisual performance",
    shortDescription: "Made with Touchdesigner & NVIDIA DeepStream SDK for Jetson Nano",
    year: "2020",
    tags: ["all","audio","remix","video","composition"],
    image: "https://toplap.org/wp-content/uploads/2020/04/FacebookBanner.jpeg",
    url: "https://www.youtube.com/watch?v=hL9QXTFQdi4"
  },
  {
    id: 1,
    name: "Re-exploring Videogames for Audiovisual Performance and Composition",
    shortDescription: "ArtScience interfaculty, master's thesis",
    year: "2020",
    tags: ["all","audio","remix","video","composition"],
    image: "https://gateway.pinata.cloud/ipfs/QmTn7VYgYVPAwZtrH8BcKjUJQU1nMrpv7gdHqEbahBbKWh/tezss.png",
    url: "https://gateway.pinata.cloud/ipfs/QmauQTbpa1ugLBNTvw2qSvGKBH5EjgA8zZUmVhkQMhvrds"
  },
  {
    id: 1,
    name: "heEeeeeyoooOoO",
    shortDescription: "2nd self-released album of Princess Camel. Includes 19 tracks. On many streaming platforms.",
    year: "2020",
    tags: ["all","audio","remix","video","composition"],
    image: "https://f4.bcbits.com/img/a3539669403_16.jpg",
    url: "https://open.spotify.com/album/2VC2onupVr3vXk893sdFFI?si=cJST6fQdRQSKLbt-hr6Yjg"
  },
  {
    id: 1,
    name: "Bastard Gan Cryptopunks",
    shortDescription: "10000 CryptoPunks are put into StyleGAN2 to give birth to bastard punks",
    year: "2020",
    tags: ["all","crypto"],
    image: "https://ipfs.daonomic.com/ipfs/QmYAL1oeHUXkQrz3dS19jsaPuAQbwkZaKYCNQxvhCjsN94",
    url: "https://app.rarible.com/bganpunks/onsale"
  },
  // {
  //   id: 1,
  //   name: "d Number",
  //   shortDescription: "Transmedial composition for drum machines, people & videos, performed in Le Dome, Caen, France",
  //   year: "2019",
  //   tags: ["all","audio","remix","video","composition"],
  //   image: "https://s3.amazonaws.com/pix.iemoji.com/images/emoji/apple/ios-12/256/clapping-hands.png",
  //   url: "https://www.youtube.com/watch?v=H3RPT2ZMvOs"
  // },
  {
    id: 1,
    name: "Deepstream <3 OSC",
    shortDescription: "Making instrument out of realtime object detection",
    year: "2020",
    tags: ["all","audio","remix","video","python"],
    image: "https://gateway.pinata.cloud/ipfs/QmRRDTWCsxqE4JfHZDzUqGRwXJKQAZ8Jox2dbkP8FR4H5U/deeposcexample2.png",
    url: "https://www.youtube.com/watch?v=6JwX-vOz1Hg"
  },
  {
    id: 1,
    name: "Variations on an Advertisement",
    shortDescription: "Algorithmic video cut composition made out of a 30 seconds long advertisement video",
    year: "2019",
    tags: ["all","audio","remix","video","composition"],
    image: rumba,
    url: "https://youtube.com/watch?v=lcP5vHo7piw"
  },
  // {
  //   id: 1,
  //   name: "Lots of Claps",
  //   shortDescription: "Transmedial composition for drum machines, people & videos, performed in Le Dome, Caen, France",
  //   year: "2019",
  //   tags: ["all","audio","remix","video","composition"],
  //   image: "https://s3.amazonaws.com/pix.iemoji.com/images/emoji/apple/ios-12/256/clapping-hands.png",
  //   url: "https://www.youtube.com/watch?v=H3RPT2ZMvOs"
  // },
  {
    id: 1,
    name: "Lots of Claps",
    shortDescription: "Transmedial composition for drum machines, people & videos, performed in Le Dome, Caen, France",
    year: "2019",
    tags: ["all","audio","remix","video","composition"],
    image: "https://s3.amazonaws.com/pix.iemoji.com/images/emoji/apple/ios-12/256/clapping-hands.png",
    url: "https://www.youtube.com/watch?v=H3RPT2ZMvOs"
  },
  {
    id: 1,
    name: "$UGARWHALE",
    shortDescription: "Audio NFT",
    year: "2020",
    tags: ["all","audio","music","composition","crypto"],
    image: "https://5w73scj45cikancjvpdabiijj6oen2g3feegzp56aw3n5xpktcaq.arweave.net/7b-5CTzokKA0SavGAKEJT5xG6NspCGy_vgW23t3qmIE",
    url: "https://mintbase.io/minter/0xd43f974bb7f15442556351e2dd4a2e5d8d7592fb/0xc5e08104c19dafd00fe40737490da9552db5bfe5"
  },
  {
    id: 1,
    name: "SERIOUS SOUND RANDOMIZER",
    shortDescription: "Jupyter Notebook script to randomize sounds in Serious Sam HD: TFE/TSE",
    year: "2020",
    tags: ["all","audio","remix","video","composition","game"],
    image: "https://logonoid.com/images/serious-sam-logo.png",
    url: "https://www.youtube.com/watch?v=xz176X4MDz4"
  },
  {
    id: 1,
    name: "Princess Camel - Album of Things #01",
    shortDescription: "Debut album of Princess Camel (on Youtube, Soundcloud and Bandcamp)",
    year: "2019",
    tags: ["all","audio","remix"],
    image: pcamel,
    url: "https://berkozdemir.bandcamp.com/album/album-of-things-01"
  },
  {
    id: 1,
    name: "vedat chili peppers",
    shortDescription: "compilation album of live performances, field recordings, tracks",
    year: "2019",
    tags: ["all","audio","noise"],
    image: vedat,
    url: "https://berkozdemir.bandcamp.com/album/vedat-chili-peppers"
  },
  {
    id: 1,
    name: "Audiosetcuts",
    shortDescription: 'Fixed media video pieces, made with lots of videos from Audioset dataset of Google, and algorithmic video cuts toolset',
    year: "2019",
    tags: ["all","software","video","python"],
    image: algocuts,
    url: "/audiosetcuts"
  },
  {
    id: 1,
    name: "Pseudo Player Performer Bot(s)",
    shortDescription: "Audiovisual composition and performance tool made in Garry's Mod and Max",
    year: "2018",
    tags: ["all","software","max","gmod","game"],
    image: pppb,
    url: "/pppb"
  },
  {
    id: 1,
    name: "<Awesome ... Solos>",
    shortDescription: "A series of videos which focus on recontexualisation of solo instrument videos",
    year: "2018",
    tags: ["all","video","youtube","remix"],
    image: awesomeSolos,
    url: "/things/awesomesolos"
  },
  {
    id: 3,
    name: "<caco></phony>",
    shortDescription: "Multimedia composition for browsers and instruments, commitioned by Hodiernal Quartet",
    year: "2017",
    tags: ["all","audio","video","composition","quartet","multimedia"],
    image: cacophony,
    url: "/things/cacophony"

  },
  {
    id: 3,
    name: "Sümeyye's Leftovers",
    shortDescription: "noise / chiptune / shitcore / popfart / philcollins duo by Berk Özdemir and Gökay Atabek",
    year: "2017",
    tags: ["all","audio","band","noise"],
    image: sumeyye,
    url: "https://www.youtube.com/channel/UCGcKKjTklJOPIzEOhQHG6sg"

  },
  // {
  //   id: 3,
  //   name: "Live visuals",
  //   shortDescription: "Live visuals made with Max/Jitter and Quartz Composer using webcam feed, random GIF images and datamoshing. Link goes to a test video.",
  //   year: "2017",
  //   tags: ["all","audiovisual","max"],
  //   image: "https://thumbs.gfycat.com/VacantWelltodoAmericanbobtail-max-1mb.gif",
  //   url: "https://www.youtube.com/watch?v=X2l8r2n_MI4"

  // },

  {
    id: 3,
    name: "dew",
    shortDescription: "A cute lo-fi music for you to dream on clouds",
    year: "2017",
    tags: ["all","audio","lo-fi"],
    image: dew,
    url: "https://www.youtube.com/watch?v=hYQBoJ03NBw"
    
  },
  {
    id: 4,
    name: "Rumba",
    shortDescription: "Python library for to generate algorithmic patterns and grids for video manipulation",
    year: "2018",
    tags: ["all","software","python","moviepy","remix"],
    image: rumba,
    url: "https://github.com/vortextemporum/Rumba"
    
  },
  {
    id: 5,
    name: "tape/md2eu",
    shortDescription: "A field recording/noise EP of an improvisation with a radio recorded in several places with multiple microphones.",
    year: "2017",
    tags: ["all","audio","bandcamp","ep","field-recording","noise"],
    image: tape,
    url: "https://berkozdemir.bandcamp.com/album/tape-md2eu"
    
  },
  {
    id: 6,
    name: "It's Safe to Just Let Go",
    shortDescription: "Hip-hop/trap track released on Spotify and other streaming platforms.",
    year: "2017",
    tags: ["all","single","audio","sampling"],
    image: letgo,
    url: "https://open.spotify.com/album/7GZ6r44ed5VK0rHXADhtkn"
    
  },
  {
    id: 6,
    name: "DARK WEBB - Berk Özdemir's Spicy Remix",
    shortDescription: "A horrible adrenaline remix of Louis Cole and DOMI's DARK WEBB.",
    year: "2018",
    tags: ["all","single","audio","remix"],
    image: darkwebb,
    url: "https://open.spotify.com/album/7GZ6r44ed5VK0rHXADhtkn"
    
  },
  {
    id: 7,
    name: "YouSeq",
    shortDescription: "A video sequencer to play downloaded Youtube videos made with Max/Jitter.",
    year: "2018",
    tags: ["all","max","sequencer","sampling","video"],
    image: youseq,
    url: "https://www.youtube.com/playlist?list=PLL-JW4H9We1xUYeK3TlqLzCrHZuvJ73MU"
    
  },
  {
    id: 7,
    name: "Avoid the Feedback!",
    shortDescription: "Kind of a non-interactive game, made in Scratch",
    year: "2017",
    tags: ["all","game","feedback","software","audio"],
    image: avoid,
    url: "/things/avoidthefeedback"
    
  },
  {
    id: 7,
    name: "Random Youtube Downloader",
    shortDescription: "A Python program to search for random Youtube videos in different languages and download them.",
    year: "2018",
    tags: ["all","software","python","sampling"],
    image: randyt,
    url: "https://github.com/vortextemporum/random-youtube-downloader"
    
  },
  {
    id: 7,
    name: "Şakirt",
    shortDescription: "Composition for solo flute, performed by Cem Önertürk",
    year: "2012",
    tags: ["all","audio","composition"],
    image: sakirt,
    url: "https://soundcloud.com/berk-ozdemir/sakirt-2012-for-solo-flute"
    
  },
  {
    id: 7,
    name: "Silly Images",
    shortDescription: "A webpage practice made while studying CSS, containing full of bullshit",
    year: "2018",
    tags: ["all","software","webart"],
    image: silly,
    url: "https://vortextemporum.github.io/sillyimages/images.html"
    
  },
  {
    id: 7,
    name: "Yamaha rm1x wallpaper generator",
    shortDescription: "Webpage made with P5.js which generates random wallpapers. Left click to generate a new one, 'a' to save as image.",
    year: "2018",
    tags: ["all","software","webart"],
    image: manual,
    url: "https://vortextemporum.github.io/onepurpose/manual.html"
    
  },
  {
    id: 7,
    name: "ri[se]t",
    shortDescription: "Video work depicting sunrise and sunset using datamoshed raw GoPro footages",
    year: "2018",
    tags: ["all","video","python","glitch","datamoshing"],
    image: riset,
    url: "https://www.youtube.com/watch?v=LYg6rAEowCs"
    
  },
  {
    id: 7,
    name: "Kenny on Mushrooms",
    shortDescription: "A love affair between Kendrick Lamar and Infected Mushrooms (clean version will be released with the debut album)",
    year: "2018",
    tags: ["all","audio,","lo-fi","sampling"],
    image: kenny,
    url: "https://www.youtube.com/watch?v=eCPZhqwi_KU"
    
  },
  {
    id: 7,
    name: "Random Youtube Player",
    shortDescription: "Max/MSP patch to play multiple random audio files downloaded from Youtube.",
    year: "2018",
    tags: ["all","max","msp","software","sampling"],
    image: youtubeplay,
    url: "https://soundcloud.com/berk-ozdemir/youtubesequencerfirst"
    
  },
  {
    id: 7,
    name: "Missing No.2",
    shortDescription: "Miniature for Alto Flute, Piano, Violin and Violoncello. Premiered by DissonArt ensemble in Thessaloniki, Greece",
    year: "2018",
    tags: ["all","audio","composition"],
    image: missingno2,
    url: "https://soundcloud.com/berk-ozdemir/missing-no-2-for-alto-flute"
    
  },
  {
    id: 7,
    name: "a new erotavarimania",
    shortDescription: "Plunderphonia of Dream Theater's Erotomatia + Octavarium and Moderat's A New Error",
    year: "2017",
    tags: ["all","audio","sampling"],
    image: "https://i1.sndcdn.com/artworks-000257311358-edc6yo-t500x500.jpg",
    url: "https://soundcloud.com/berk-ozdemir/amazing-labrie-loop"
  },
  {
    id: 7,
    name: "NASTY!",
    shortDescription: "A very nasty Industrial-Noise-Hophop track",
    year: "2017",
    tags: ["all","audio"],
    image: "https://i1.sndcdn.com/artworks-000237951559-2hozab-t500x500.jpg",
    url: "https://soundcloud.com/berk-ozdemir/nasty"
  },
  {
    id: 7,
    name: "berkozdemir.com",
    shortDescription: "This website you're browsing was my first project with React.js. (Includes p5 sketches)",
    year: "2018",
    tags: ["all","webart"],
    image: website,
    url: "https://berkozdemir.com"
  },
  {
    id: 3,
    name: "BLOCKS",
    shortDescription: "A modular composition for a Flute Quartet where performers prepare their own scores",
    year: "2017",
    tags: ["all","audio","composition"],
    image: blocks,
    url: "https://www.dropbox.com/s/rqqeu4ebev5jk8i/Blocks%20Final.pdf"

  }
]


// WEBPACK FOOTER //
// ./src/components/portfolio/projectlist.jsx